import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NavBarComponent } from './nav-bar/nav-bar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ClientApp';
  cookieMessage = "Our Websites use first party and third party cookies. These cookies help us to understand the people who visit our Websites by enabling us to collect browsing and usage statistics, reach users with more relevant ads, and personalize content. Opt-out of certain cookies and manage your cookie preferences for our Websites at any time via our Cookie Preferences tool. ";
  cookieDismiss = "Ok";
  cookieLinkText = "Privacy Policy";
  cookieUrlCookiePrivacity = "https://www.willistowerswatson.com/en-US/Notices/global-website-privacy-notice";


  @ViewChild(NavBarComponent) navBar: NavBarComponent;

  constructor(
    private translate: TranslateService,
    private jwtHelper: JwtHelperService,
  ) {
    //debugger;
    translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    let cc = window as any;
    cc.cookieconsent.initialise({
      palette: {
        popup: {
          background: "#f2f2f2"
        },
        button: {
          background: "#702082",
          text: "#ffffff"
        }
      },
      theme: "classic",
      content: {
        message: this.cookieMessage,
        dismiss: this.cookieDismiss,
        link: this.cookieLinkText,
        href: this.cookieUrlCookiePrivacity 
      }
    });
  }

  //Función implementada para setear el idioma al Translate Service
  setLanguage(lang) {
    this.translate.use(lang);
  }

  getJwt(from: any) {
    let token = sessionStorage.getItem('jwt');

    let flag = token != null;
    if (!flag) {
      sessionStorage.removeItem('userInfo');
    }
    return flag;
  }

}
